import { FormValues, SchedulerConfig } from "../Interface/scheduler/form";

const getChildForCommercialInputFlow = (
  formConfig: SchedulerConfig,
  current: number,
  formValues: FormValues,
) => {
  const contactUsFormIndex = formConfig.steps[current]?.elements.findIndex(
    (elem) => elem.id === "contact-us-form",
  );

  if (contactUsFormIndex === undefined) {
    return undefined; // contact-us-form not found
  }

  const contactUsFormElement =
    formConfig.steps[current]?.elements[contactUsFormIndex];

  if (!contactUsFormElement) {
    return undefined; // element not found
  }

  const userinfoServiceTypeIndex = contactUsFormElement.fields.findIndex(
    (field) => field.id === "userinfoServiceType",
  );

  if (userinfoServiceTypeIndex === undefined) {
    return undefined; // userinfoServiceType not found
  }

  const userinfoServiceTypeField =
    contactUsFormElement?.fields[userinfoServiceTypeIndex];

  const acessingUserInfoServiceType = userinfoServiceTypeField?.options?.find(
    (option) => option.id === formValues.userinfoServiceType,
  );

  if (!acessingUserInfoServiceType) {
    return undefined; // option not found
  }

  const childUserInfo = acessingUserInfoServiceType.child?.find(
    (child) => child.id === "commercialInputFlow",
  );

  return childUserInfo;
};

export default getChildForCommercialInputFlow;
